import { render } from "./cart-samples.vue?vue&type=template&id=39161c0f"
import script from "./cart-samples.vue?vue&type=script&lang=js"
export * from "./cart-samples.vue?vue&type=script&lang=js"

import "./cart-samples.vue?vue&type=style&index=0&id=39161c0f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__